import $ from 'jquery'
import _ from 'underscore'

import StateManager from './scuba/StateManager'
import LayoutManager from './scuba/LayoutManager'
import HorizontalLayout from './scuba/HorizontalLayout'
import MobileLayout from './scuba/MobileLayout'
import m from './components/Modal'

require('./scuba/Navigation')
require('./scuba/Content')
require('./scuba/ListForm')
require('./scuba/ListSnap')
require('./scuba/ListLazyLoading')
require('./scuba/Menu')

require('./components/Accordions')
require('./components/Form')
require('./components/ImageHover')
require('./components/LightBox')
require('./components/Posts')
require('./components/Search')
require('./components/Signout')
require('./components/Sticky')
require('./components/Flipflop')
require('./components/Flickity')
require('./components/ResizeText')
require('./components/AutoFocus')
require('./components/Fonts')

// gestionnaire de layout
LayoutManager.setLayouts([new HorizontalLayout(), new MobileLayout()])

// initialisation
$(document).ready(function() {
  var $body = $(document.body)
  var $wrap = $('.js-scuba__wrap').first()
  var $head = $('.js-scuba__head').first()
  var $main = $('.js-scuba__main').first()
  if (!$wrap.length) {
    $wrap = $('<div class="js-scuba__wrap"></div>').prependTo($body)
    $head.appendTo($wrap)
    $main.appendTo($wrap)
  }

  $(document).on('click', '.js-disable-after-click', function(event) {
    $(event.currentTarget)
      .css({
        opacity: 0.5,
        cursor: 'not-allowed'
      })
      .on('click', function() {
        return false
      })
  })

  $(document).on('click', 'a', function(event) {
    // récupération du lien
    var $link = $(event.currentTarget)

    // récupération des informations
    var href = $link.attr('href')
    var target = $link.attr('target')
    var dataTarget = $link.attr('data-target')
    // var dataHeight = $link.attr('data-height') ||  ( parseInt( $(window).height() * 0.9 ) ) ;
    // var dataWidth = $link.attr('data-width') || Math.min ( parseInt( ( $(window).width() * 0.9 ) ) , 768 ) ;
    var callback = $link.attr('data-callback') || null
    if (
      $(event.currentTarget)[0].href.includes('mailto') ||
      $(event.currentTarget)[0].href.includes('logout')
    ) {
      false
    } else if (
      (typeof href !== 'undefined' &&
        location.hostname !== $(event.currentTarget)[0].hostname &&
        !$(event.currentTarget).hasClass('no-target-blank') &&
        href.indexOf('http') !== -1) ||
      $(event.currentTarget)[0].pathname.indexOf('.') !== -1
    ) {
      window.open(href, '_blank')
      event.preventDefault()
    }
    if (target !== '_blank') {
      // lien à gérer par un JS
      if (href === '#') {
        if (callback && callback != '') eval(callback)
        event.preventDefault()
      }
      // liens de DGT NAV
      else if (dataTarget && dataTarget === 'reload') {
        false
      } else if (
        (dataTarget && dataTarget !== 'cover') ||
        $link.closest('.js-scuba__nav').length
      ) {
        event.preventDefault()

        // récupère le page url pour retrouver le contexte en self ou after
        var pageUrl = $link
          .closest('.js-scuba__head,.js-scuba__page')
          .data('url')

        // montre qu'on charge le lien
        $link.addClass('is-loading')
        if ($(event.currentTarget).hasClass('no-target-blank')) {
          window.open(href, '_self')
        } else {
          StateManager.pushState(href, dataTarget, pageUrl).fin(function() {
            // remet dans l'état normal
            $link.removeClass('is-loading')
          })
        }
      }
    }
  })

  $(document).on('click', '.js-scuba__back', function(event) {
    StateManager.popState()
    event.preventDefault()
  })

  $(window).on(StateManager.STATE_CHANGE, function(event, state) {
    var lastPage = _.last(state)
    if (lastPage) {
      var $page = lastPage.$element
      var url = $page.data('url')
      ga('send', 'pageview', url)
      // condition for google tracking
      var isStats = typeof window._gaq != 'undefined' && url != null
      if (isStats) {
        window._gaq.push(['_trackPageview'], url)
      }
    }
  })

  $(window).on(StateManager.STATE_CHANGE, function(state) {
    const layout = LayoutManager.getAvailableLayout()
    const isMobile = layout && layout.name === 'MobileLayout'
    if (isMobile) {
      return
    }
    if ($main.find('.js-scuba__page[data-show-one-menu-section]').length) {
      $body.addClass('scuba-show-one-menu-section')
    } else {
      if ($body.hasClass('scuba-show-one-menu-section')) {
        $body.removeClass('scuba-show-one-menu-section')
        layout.scroll.to(layout.scroll.maxScrollLeft(), 0)
      }
    }
  })

  StateManager.init()
    .then(function() {
      LayoutManager.start().then(function() {
        $(document.body).removeClass('is-loading')
      })
    })
    .then(function() {
      const layout = LayoutManager.getAvailableLayout()
      const isDesktop = layout && layout.name === 'HorizontalLayout'
      if (isDesktop && !$body.hasClass('scuba-show-one-menu-section')) {
        setTimeout(function() {
          layout.scroll.to(layout.scroll.maxScrollLeft(), 0)
        }, 100)
        //layout.scroll.to(layout.scroll.maxScrollLeft(), 0)
      }
    })
    .fail(function(reason) {
      console.error(reason && reason.stack ? reason.stack : reason)
    })
})



// WEBPACK FOOTER //
// ./scripts/main.js